import React, { Fragment, useEffect, useState, Suspense } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./css/noticias.css";
import Swiper from "react-id-swiper";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Server } from "../../constants";

const Image = React.lazy(() => import("react-bootstrap/Image"));

function CarouselNoticias() {
  const [noticias, setNoticias] = useState([]);
  const httpsRegex = new RegExp("^http[s]?://");
  const params = {
    observer: true,
    observeParents: true,
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    speed: 600,
    spaceBetween: 0,
  };

  useEffect(() => {
    const getNoticias = async () => {
      const url = `${Server}/api/obtener_noticias_carrusel/1`;
      try {
        const resultado = await axios.get(url);
        setNoticias(resultado.data);
      } catch (error) {
        console.error("Error fetching noticias:", error);
      }
    };
    getNoticias();
  }, []);

  const tipoUrl = (noticia) => {
    if (httpsRegex.test(noticia.NOT_URL)) {
      return (
        <Link
          className="text-decoration-none"
          onClick={(event) => {
            window.open(noticia.NOT_URL, "_blank");
          }}
        >
          <h2 className="press-title mt-2">{noticia.NOT_TITULO}</h2>
          <span className="read-more-press mt-4">
            Leer más
            <FontAwesomeIcon icon={faAngleRight} className="pt-1" />
          </span>
        </Link>
      );
    } else {
      return (
        <Link to={noticia.NOT_URL} className="text-decoration-none">
          <h2 className="press-title mt-2">{noticia.NOT_TITULO}</h2>
          <span className="read-more-press mt-4">
            Leer más
            <FontAwesomeIcon icon={faAngleRight} className="pt-1" />
          </span>
        </Link>
      );
    }
  };

  return (
    <Fragment>
      <Container className="py-4 py-md-5" style={{ height: "568px", overflow: "hidden" }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Swiper {...params} className="mt-5">
            {noticias.map((noticia) => (
              <div key={noticia.NOT_CODIGO}>
                <Container className="bg-sand">
                  <Row>
                    <Col md={8} className="p-0">
                      <Image
                        width="740"
                        height="432"
                        src={noticia.NOT_URL_IMAGEN.replace(".jpg", ".webp")}
                        alt="Hyundai Motorsport"
                        loading="lazy"
                        className="oferta-image"
                        fluid
                      />
                    </Col>
                    <Col md={4} className="my-auto pr-md-5">
                      <span className="press-date">
                        {moment(noticia.NOT_FECHA).format("DD/MM/YYYY")}
                      </span>
                      {tipoUrl(noticia)}
                    </Col>
                  </Row>
                </Container>
              </div>
            ))}
          </Swiper>
        </Suspense>
        <div className="mt-md-3 text-center">
          <a href="/noticias" className="custom-button">
            Ver más noticias aquí
          </a>
        </div>
      </Container>
    </Fragment>
  );
}
export default CarouselNoticias;